export default __webpack_public_path__ + "locales/tr/Files.json?hash=8940e976f20681fdaff88376f54b4fbd";